<rcp-com-card
    cardClass="bg-white
    {{ isInsightsDetailView ? '' : 'border border-gray-border' }}"
    [hasHeader]="false">
    <div
        class="flex flex-col h-full
        {{ isInsightsDetailView ? 'p-1' : 'p-4' }}"
        rcpComLoadingOverlay
        [isLoading]="isLoading">
        @if (!isInsightsDetailView) {
            <h6 class="font-semibold uppercase mb-3">
                Aged Claim Progress
                <span class="text-sm text-gray-500">(This Month)</span>
            </h6>
        }
        <div class="flex flex-row justify-between mb-3">
            <div class="flex flex-col">
                <span class="font-semibold text-[22px]">{{
                    workedClaims
                }}</span>
                <span class="text-sm text-gray-500"
                    >Claims Worked ({{ workedClaimPercent }}%)</span
                >
            </div>
            <div class="flex flex-col text-right">
                <span class="font-semibold text-[22px]">{{ totalClaims }}</span>
                <span class="text-sm text-gray-500">Total Claims</span>
            </div>
        </div>
        <div>
            <mat-progress-bar
                mode="determinate"
                [value]="workedClaimPercent"></mat-progress-bar>
        </div>
        @if (!isInsightsDetailView) {
            <div class="mt-4">
                <rcp-com-button
                    [buttonStyle]="ButtonStyle.Tertiary"
                    label="View Details"
                    (clickEvent)="routeToReport()"></rcp-com-button>
            </div>
        }
    </div>
</rcp-com-card>
